import { SparkleIcon } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

import { AI_GOVERNANCE_ICON_LABEL } from './labels'

type AIGovernanceIconProps = {
  className?: string
}

export const AIGovernanceIcon = ({ className }: AIGovernanceIconProps) => (
  <SparkleIcon
    aria-label={AI_GOVERNANCE_ICON_LABEL}
    role='img'
    className={cn('size-3 shrink-0 text-main-foreground-accent', className)}
  />
)
